import React from 'react';

const SvgSquareCorner = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3h18v2H5v14h16v2H3V3z"
      fill="currentColor"
    />
  </svg>
);

export default SvgSquareCorner;
